import { Flex } from "antd";
import { FC, useRef } from "react";
import { ContractProduct, Product } from "tm-shared/types";

import { PrimaryText } from "@/components/Typography/Styled";
import { useInViewObserver } from "@/hooks/useInViewObserver";

import { StyledCheckbox } from "./Styled";

interface CheckboxProductRowProps {
    product: Product;
    checked: boolean;
    isLast: boolean;
    onChange: (product: ContractProduct, checked: boolean) => void;
    onInView: () => void;
}

export const CheckboxProductRow: FC<CheckboxProductRowProps> = ({
    product,
    checked,
    isLast,
    onChange,
    onInView,
}) => {
    const cardRef = useRef<HTMLDivElement>(null);

    useInViewObserver(cardRef, () => {
        if (isLast) onInView();
    });

    return (
        <div ref={cardRef}>
            <StyledCheckbox
                checked={checked}
                onChange={(e) =>
                    onChange(
                        {
                            barcode: product.barcode,
                            quantity: 1,
                            price: 0,
                            name: product.name,
                        },
                        e.target.checked,
                    )
                }
            >
                <PrimaryText fontSize={16}>{product.name}</PrimaryText>
                <Flex gap={4}>
                    <PrimaryText>Штрихкод:</PrimaryText>
                    <PrimaryText fontWeight="700">
                        {product.barcode}
                    </PrimaryText>
                </Flex>
            </StyledCheckbox>
        </div>
    );
};
